/**
 * Sport icon resolver — PNG asset 기반
 * fallback: null (caller가 emoji/text 대체)
 */
import soccerIcon from './assets/soccer.png';
import basketballIcon from './assets/basketball.png';
import baseballIcon from './assets/baseball.png';
import icehockeyIcon from './assets/icehockey.png';
import volleyballIcon from './assets/valleyball.png';

const SPORT_ICON_MAP = {
  // English keys
  'football': soccerIcon,
  'soccer': soccerIcon,
  'basketball': basketballIcon,
  'baseball': baseballIcon,
  'hockey': icehockeyIcon,
  'ice hockey': icehockeyIcon,
  'icehockey': icehockeyIcon,
  'volleyball': volleyballIcon,
  // Korean keys
  '축구': soccerIcon,
  '농구': basketballIcon,
  '야구': baseballIcon,
  '아이스하키': icehockeyIcon,
  '배구': volleyballIcon,
};

export function getSportIconUrl(sport) {
  if (!sport) return null;
  const slug = (sport.slug || '').toLowerCase().trim();
  const name = (sport.name || '').toLowerCase().trim();
  const nameKo = (sport.name_ko || '').trim();
  return SPORT_ICON_MAP[slug] || SPORT_ICON_MAP[name] || SPORT_ICON_MAP[nameKo] || null;
}

export default getSportIconUrl;
